import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'

import { AccessType } from 'app/auth/accessControlService'

import EmptyState from 'app/componentV4/EmptyState'
import ComposeMessageButton from 'app/componentV4/Button/ComposeMessageButton'
import { ReactComponent as EmptyMessageIcon } from 'app/components/icons/empty-message-icon.svg'
import Assets from 'app/configs/assetConfigs'

const EmptyMessagePage = ({ onOpenCreateNotification, isFavoritePath }) => {
  const user = useSelector(({ auth }) => auth.user.data)
  const { formatMessage } = useIntl()

  return (
    <EmptyState
      icon={
        isFavoritePath ? (
          <img src={Assets.noFavoritesIcon} alt="No favorites icon" />
        ) : (
          <EmptyMessageIcon />
        )
      }
      title={formatMessage(
        {
          id: 'timeline.notification.empty.title',
        },
        { fullName: `${user.firstName} ${user.lastName}` },
      )}
      description={formatMessage({
        id: isFavoritePath
          ? 'timeline.favorite.empty.detail'
          : 'timeline.notification.empty.description',
      })}
      accesses={[AccessType.NOTIFICATION_SEND, AccessType.ADMINISTRATION]}
      onAction={
        isFavoritePath ? null : (
          <ComposeMessageButton onClick={onOpenCreateNotification} />
        )
      }
    />
  )
}

EmptyMessagePage.propTypes = {
  onOpenCreateNotification: PropTypes.func.isRequired,
  isFavoritePath: PropTypes.bool.isRequired,
}

export default EmptyMessagePage
